/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Gallery_Report_LabelInputs */

const en_us2_gallery_report_label = /** @type {(inputs: Gallery_Report_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Report: ${i?.title}`)
};

const pt_br2_gallery_report_label = /** @type {(inputs: Gallery_Report_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Denunciar: ${i?.title}`)
};

const pt_pt2_gallery_report_label = /** @type {(inputs: Gallery_Report_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Denunciar: ${i?.title}`)
};

/** @type {(inputs: Gallery_Report_LabelInputs) => LocalizedString} */
const es_419_gallery_report_label = en_us2_gallery_report_label;

/** @type {(inputs: Gallery_Report_LabelInputs) => LocalizedString} */
const fr_fr2_gallery_report_label = en_us2_gallery_report_label;

/** @type {(inputs: Gallery_Report_LabelInputs) => LocalizedString} */
const de_de2_gallery_report_label = en_us2_gallery_report_label;

/** @type {(inputs: Gallery_Report_LabelInputs) => LocalizedString} */
const it_it2_gallery_report_label = en_us2_gallery_report_label;

/**
* | output |
* | --- |
* | "Report: {title}" |
*
* @param {Gallery_Report_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gallery_report_label = /** @type {((inputs: Gallery_Report_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Report_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gallery_report_label(inputs)
	if (locale === "es-419") return es_419_gallery_report_label(inputs)
	if (locale === "pt-PT") return pt_pt2_gallery_report_label(inputs)
	if (locale === "fr-FR") return fr_fr2_gallery_report_label(inputs)
	if (locale === "de-DE") return de_de2_gallery_report_label(inputs)
	if (locale === "it-IT") return it_it2_gallery_report_label(inputs)
	return en_us2_gallery_report_label(inputs)
});
export { gallery_report_label as "gallery.report_label" }